import React from "react";
import useSizePercentage from "../hooks/useSizePercentage";
import BackgroundDiv from "../misc/elements/BackgroundDiv";

const DetailedDescription = ({ description }) => {
  const sizePercentage = useSizePercentage();
  return (
    <div
      className="divColumn"
      style={{ justifyContent: "center", width: "100%" }}
    >
      <div
        className="divRow"
        style={{
          position: "relative",
          padding: "5px",
          width: "90%",
          justifyContent: "center",
        }}
      >
        <BackgroundDiv
          backgroundColor={"#2f2f2f"}
          borderBottom={true}
          opacity={0.8}
        />
        <div className="textBoldWhite" style={{ fontSize: "18px", zIndex: 1 }}>
          Long Description
        </div>
      </div>
      <div
        className="divRow"
        style={{
          position: "relative",
          width: "93%",
          textAlign: "center",
          overflowY: "auto",
          height: sizePercentage.height,
        }}
      >
        <BackgroundDiv
          backgroundColor={"#5f5f5f"}
          borderTop={true}
          opacity={0.8}
        />
        <div
          className="textWhite"
          style={{
            zIndex: 1,
            fontStyle: "italic",
            fontSize: "17px",
            paddingTop: "5px",
          }}
        >
          {description}
        </div>
      </div>
    </div>
  );
};

export default DetailedDescription;
